import {Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material';

@Component({
  selector: 'app-error-message',
  template: `
    <div align="center" class="col_yellow">
      <span *ngIf="!isNotFormError">Form Validation Errors</span>
      <span *ngIf="isNotFormError && !isWarning">Error</span>
      <span *ngIf="isNotFormError && isWarning">Warning</span>
      <button aria-label="Close" class="close opacity_1_imp" type="button">
        <span aria-hidden="true" class="col_yellow"
              (click)="snackBarRef.dismiss()">×</span>
      </button>
    </div>
    <div class="padding_3" *ngFor="let err of data">
      <div class="bg-red border_radius_10 padding_0_5_imp">
        <span class="color-white">{{err?.defaultMessage}}</span>
      </div>
    </div>
  `
})
export class ErrorMessageComponent implements OnInit {
  isNotFormError: boolean = false;
  isWarning: boolean = false;
  constructor(public snackBarRef: MatSnackBarRef<ErrorMessageComponent>,
              @Inject(MAT_SNACK_BAR_DATA) public data: any[]) {
    if(this.data.length === 1 && this.data[0].isNotFormError === true) {
      this.isNotFormError = true;
    }
    if(data.length === 1 && data[0].isWarning === true) {
      this.isWarning = data[0].isWarning;
    }
  }

  ngOnInit() {
  }

}
